module.exports = __webpack_public_path__ + "static/media/hero-540.367e1251.jpg";